// extracted by mini-css-extract-plugin
export default {"logo":"search-results-container_logo__VR+SX","heading":"search-results-container_heading__iiKvO","filterContainer":"search-results-container_filterContainer__yy6fj"};